import(/* webpackMode: "eager", webpackExports: ["DocsFrame"] */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/docs/DocsFrame.tsx");
